import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'
import { Data } from '@/modules/shared/models/data'

export enum DepositBankAccountStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export interface DepositBankAccountResourceModel {
  account_number: string,
  account_owner_name: string,
  account_type: BankAccountType,
  card_number: string,
  default: boolean,
  id: number,
  sheba: string,
  status: DepositBankAccountStatus,
  title: string,
  total_deposit_amount: number
}

export interface BasicDepositBankAccountResourceModel {
  id: number,
  title: string
}

export interface DepositBankAccountResourceWithModel {
  account_types: { [key in BankAccountType]: string }
  statuses: { [key in DepositBankAccountStatus]: string }
}

export type DepositBankAccountResourceType = Data<DepositBankAccountResourceModel> & DepositBankAccountResourceWithModel
